import { Activity } from '~/types/bootcamp'
import { BootcampActivityEventId } from '~/bootcamp/types/bootcamp.types'
import { getActivityDiffLevelsCount } from '~/bootcamp/pages/BootcampView/BootcampView.utils'
import { getBootcampActivityEventsForCurrentRound } from '~/bootcamp/utils/bootcamp.utils'
import { selectCurrentActivityType, selectCurrentRound } from '~/bootcamp/slices/bootcamp-activity.slice'
import { useAppSelector } from '~/redux/hooks'

export default function useGetCurrentDifficultyLevel(
  eventIds: BootcampActivityEventId[],
  activities: Activity[],
): [difficultyLevel: number, hasCompletedAllDifficultyLevel: boolean] {
  const currentRound = useAppSelector(selectCurrentRound)
  const events = getBootcampActivityEventsForCurrentRound(eventIds, currentRound)
  const activityType = useAppSelector(selectCurrentActivityType)

  const activityDiffLevelsCount = getActivityDiffLevelsCount(activities, activityType)
  const activityDiffLevels = new Array(activityDiffLevelsCount).fill(null).map((_, index) => index + 1)
  const completedDiffLevels = new Set(events.map((elem) => elem.difficultyLevel))
  const targetDiffLevel = activityDiffLevels.find((value) => !completedDiffLevels.has(value))
  return [targetDiffLevel || activityDiffLevelsCount, !targetDiffLevel]
}
